import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { FiasAddress, FiasAPI, FiasFields, FiasSearch } from '@skbkontur/react-ui-addons';
import { ValidationWrapper } from '@skbkontur/react-ui-validations';
import { isCloud } from '../../helpers/isCloud';
export const RegionSearchField = ({ value, onValueChange, validationInfo, width = 266, }) => {
    const [fiasAPI] = useState(new FiasAPI({
        baseUrl: `https://api.${isCloud() ? 'testkontur' : 'kontur'}.ru/fias/v1.2/`,
    }));
    const [address, setAddress] = useState(undefined);
    const renderItem = (item) => (_jsxs("div", { children: [item.fields.region?.data?.code.substring(0, 2), " ", item.getText()] }));
    useEffect(() => {
        if (!value || value.fiasId === address?.getFiasId()) {
            return;
        }
        void (async () => {
            try {
                const searchResult = await fiasAPI.search({
                    fiasId: value.fiasId,
                });
                const addressResponse = searchResult.data?.[0];
                if (!addressResponse) {
                    throw new Error('wrong fias id');
                }
                setAddress(FiasAddress.createFromResponse(addressResponse));
            }
            catch {
                setAddress(undefined);
            }
        })();
    }, [value]);
    useEffect(() => {
        if (!onValueChange) {
            return;
        }
        if (!address) {
            onValueChange(null);
            return;
        }
        onValueChange({
            fiasId: address.getFiasId(),
            name: address.getText(),
        });
    }, [address]);
    return (_jsx(ValidationWrapper, { validationInfo: validationInfo, children: _jsx(FiasSearch, { api: fiasAPI, width: width, searchOptions: { field: FiasFields.region }, onValueChange: setAddress, address: address, placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0434 \u0438\u043B\u0438 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435", renderItem: renderItem }) }));
};
